
      const s=document.createElement('script');s.async=true;
      s.src='https://www.googletagmanager.com/gtag/js?id={{GA_MEASUREMENT_ID}}';
      document.head.appendChild(s);
      gtag('config','{{GA_MEASUREMENT_ID}}',{send_page_view:false});
    